import React from 'react';
import { isMobileVersion } from '../../lib/soar-helper';
import styled from 'styled-components';
import { Category } from '../../api/model';
import { ListingGroup } from '../../store/Map/MapSelection/model';
import profileIconUrl from '../Dashboard/profile-icon-url';
import SearchResultsBreadcrumbs from './search-results-breadcrumbs';

interface SearchResultsEmptyViewProps {
    isLoading: boolean;
    continent?: ListingGroup;
    category?: Category;
    term?: string;
    noMaps?: boolean;
}

const SearchResultsEmptyView = (props: SearchResultsEmptyViewProps) => {
    if (props.isLoading && (!props.continent || !props.category || !props.term)) {
        return <React.Fragment />;
    }

    const icon = props.continent?.continent?.iconUrl || props.category?.iconUrl;

    return (
        <EmptySearchView>
            {props.noMaps ? (
                <>
                    {icon ? <SearchImage src={icon} /> : <SearchImage src={profileIconUrl.noImagesUrl} />}

                    <EmptySearchText>
                        There are no maps to display on your subdomain.
                        {isMobileVersion && (
                            <EmptySearchHelpText>You can upload maps using a desktop computer.</EmptySearchHelpText>
                        )}
                    </EmptySearchText>
                </>
            ) : (
                <>
                    {icon ? <SearchImage src={icon} /> : <SearchIcon className="fa fa-search" />}
                    <EmptySearchText>
                        We searched the communities maps for <SearchResultsBreadcrumbs /> but found no results.
                        <EmptySearchHelpText>
                            Try changing the search to see what else you can find.
                        </EmptySearchHelpText>
                    </EmptySearchText>
                </>
            )}
        </EmptySearchView>
    );
};

export default SearchResultsEmptyView;

const EmptySearchView = styled.div`
    color: white;
    width: 55%;
    height: 50%;
    position: absolute;
    top: 20%;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;

    @media only screen and (max-width: 600px) {
        width: 90%;
        bottom: 0;
        top: auto;
    }
`;

const SearchIcon = styled.i`
    color: #eed926;
    font-size: 74px;
    position: absolute;
    left: -15px;
    top: -15px;
    border: 3px solid #eed926;
    padding: 10px;
    z-index: 99999;
    border-radius: 8px;
    background: #191a1a;
    box-shadow: 0px 11px 14px -7px rgb(0 0 0 / 30%), 0px 23px 36px 3px rgb(0 0 0 / 24%),
        0px 9px 44px 8px rgb(0 0 0 / 22%);

    @media only screen and (max-width: 600px) {
        border: 2px solid #eed926;
        margin-bottom: -50px;
        position: initial;
    }
`;

const SearchImage = styled.img`
    width: 100px;
    height: 100px;
    position: absolute;
    left: -15px;
    top: -15px;
    border: 3px solid #eed926;
    padding: 10px;
    background: #06070a;
    z-index: 99999;
    border-radius: 8px;
    background: #191a1a;
    box-shadow: 0px 11px 14px -7px rgb(0 0 0 / 30%), 0px 23px 36px 3px rgb(0 0 0 / 24%),
        0px 9px 44px 8px rgb(0 0 0 / 22%);

    @media only screen and (max-width: 600px) {
        border: 2px solid #eed926;
        margin-bottom: -50px;
        position: initial;
    }
`;

const EmptySearchText = styled.div`
    color: white;
    margin: 25px;
    font-size: 18px;
    border: 2px solid #eed926;
    padding: 50px 35px 55px 70px;
    border-radius: 8px;
    background: #191a1a;
    text-align: left;

    @media only screen and (max-width: 600px) {
        font-size: 16px;
        margin: auto;
        padding: 60px 30px 60px 30px;
        text-align: center;
    }
`;

const EmptySearchHelpText = styled.div`
    margin-top: 20px;
    color: white;
    font-size: 14px;
`;
